// Toast.tsx — Componente de notificaciones que consume el ToastContext
// CONCEPTO: Componente consumidor de Context
// Este componente usa useToast() para obtener el listado de toasts activos
// y renderizarlos. Está completamente desacoplado de quién los dispara.

import { useToast } from '../../context/ToastContext';
import { CloseIcon } from '../Icons/Icons';
import styles from './Toast.module.css';

export function ToastContainer() {
  // useToast() — accede al contexto global de toasts
  const { toasts, dismissToast } = useToast();

  // Si no hay toasts, no renderizar el contenedor (optimización)
  if (toasts.length === 0) return null;

  return (
    // role="region" + aria-label — identifica la región para lectores de pantalla
    <div className={styles.container} role="region" aria-label="Notificaciones">
      {/* Iterar el array de toasts y renderizar cada uno.
          "key" es requerida por React cuando renderiza listas para optimizar
          el Virtual DOM diff — identifica qué elemento cambió, se agregó o eliminó. */}
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`${styles.toast} ${styles[toast.variant ?? 'info']}`}
          role="alert"           // Anuncia el toast a lectores de pantalla inmediatamente
          aria-live="polite"     // El lector espera a que el usuario termine de leer
        >
          <span className={styles.icon} aria-hidden="true">{toast.icon}</span>
          <div>
            <p className={styles.title}>{toast.title}</p>
            {toast.subtitle && <p className={styles.subtitle}>{toast.subtitle}</p>}
          </div>
          {/* Botón de cierre manual */}
          <button
            className={styles.close}
            onClick={() => dismissToast(toast.id)}
            aria-label="Cerrar notificación"
          >
            <CloseIcon />
          </button>
        </div>
      ))}
    </div>
  );
}
